import { useWindowWidth } from '@libs/common-next';
import { Grid, TextField } from '@petsmart-ui/sparky';
import type { NameFieldsProps } from './types';

function RenderNameFields({ values, touched, errors, onBlur, onChange }: Readonly<NameFieldsProps>) {
    return (
        <>
            <Grid.Item>
                <TextField
                    data-testid="firstName"
                    data-cs-mask
                    wrapperTestId="firstName-field"
                    id="firstName"
                    label="First name"
                    name="firstName"
                    type="text"
                    value={values.firstName}
                    onBlur={onBlur}
                    onChange={onChange}
                    isError={touched.firstName && !!errors.firstName}
                    fieldNote={touched.firstName && errors.firstName?.[0]}
                />
            </Grid.Item>
            <Grid.Item>
                <TextField
                    data-testid="lastName"
                    data-cs-mask
                    wrapperTestId="lastName-field"
                    id="lastName"
                    label="Last name"
                    name="lastName"
                    type="text"
                    value={values.lastName}
                    onBlur={onBlur}
                    onChange={onChange}
                    isError={touched.lastName && !!errors.lastName}
                    fieldNote={touched.lastName && errors.lastName?.[0]}
                />
            </Grid.Item>
        </>
    );
}

export function NameFields({ vertical = false, ...props }: NameFieldsProps) {
    const { isMobile } = useWindowWidth();

    return !vertical && !isMobile ? (
        <Grid.Item>
            <Grid variant="side-by-side" gap="sm">
                <RenderNameFields {...props} />
            </Grid>
        </Grid.Item>
    ) : (
        <RenderNameFields {...props} />
    );
}
